module.exports = __webpack_public_path__ + "static/media/loading.4422e2a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/loading.svg
// module id = 425
// module chunks = 0